









































































































import { UnitInfo } from "@/constants";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HadUnitListComponent extends Vue {
  @Prop() msg!: number;
  @Prop() ssrUnits!: UnitInfo[];
  @Prop() ssrNums!: number[];
  readonly viewNum = 100;
  get maskedSSRUnits(): (UnitInfo | null)[] {
    return this.ssrUnits
      ? this.ssrUnits.map((v, i) => (this.ssrNums[i] > 0 ? v : null))
      : [];
  }
  get currentPageMaskedSSRUnits(): (UnitInfo | null)[] {
    return this.maskedSSRUnits.slice(
      this.currentPage * this.viewNum,
      (this.currentPage + 1) * this.viewNum
    );
  }
  unitListDialog = false;
  unitDetailDialog = false;
  removeUnitsDialog = false;
  currentUnit: UnitInfo = this.ssrUnits[0];
  currentPage = 0;
  get maxPage(): number {
    return this.ssrUnits ? Math.floor(this.ssrUnits.length / this.viewNum) : 0;
  }
  addPage(add: boolean): void {
    add ? this.currentPage++ : this.currentPage--;
    this.currentPage = Math.max(0, Math.min(this.currentPage, this.maxPage));
  }
  /**
   * current unitを所持済みの前後に移動
   * @param next 次の時はtrue、前の時はfalse
   */
  moveCurrentUnit(next: boolean): void {
    const i = this.maskedSSRUnits.findIndex(
      (v) => v?.name === this.currentUnit.name
    );
    const moveToUnit = next
      ? this.maskedSSRUnits.slice(i + 1).filter((v) => v)[0]
      : this.maskedSSRUnits
          .slice(0, i)
          .reverse()
          .filter((v) => v)[0];
    if (moveToUnit) this.currentUnit = moveToUnit;
  }
  removePrefix(str: string) {
    return str ? str.replace("（SSR）", "") : str;
  }
  clickRemove() {
    this.$emit("removeUnits");
    this.removeUnitsDialog = false;
  }
}
